const STORAGE_KEY = 'voiceMessagePlaybackRateIndex';

export const VOICE_MESSAGE_PLAYBACK_RATES = [1, 1.5, 2];

const RATE_COUNT = VOICE_MESSAGE_PLAYBACK_RATES.length;

const listeners = new Set();

let memoryIndex = 0;
let hydrated = false;
let hydratePromise = null;

function clampIndex(n) {
  if (!Number.isFinite(n) || n < 0 || n >= RATE_COUNT) {
    return 0;
  }
  return Math.floor(n);
}

function notify() {
  listeners.forEach(l => {
    try {
      l();
    } catch {
      /* ignore */
    }
  });
}

/**
 * In-memory index (0 … RATE_COUNT - 1). Hydrate before first channel UI for correct initial state.
 */
export function getVoiceMessagePlaybackRateIndex() {
  return memoryIndex;
}

export function setVoiceMessagePlaybackRateIndex(index) {
  const next = clampIndex(index);
  if (next === memoryIndex) {
    return;
  }
  memoryIndex = next;
  try {
    localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    /* quota / private mode */
  }
  notify();
}

export function subscribeVoiceMessagePlaybackRateIndex(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export async function hydrateVoiceMessagePlaybackRateIndex() {
  if (hydrated) {
    return Promise.resolve();
  }
  if (!hydratePromise) {
    hydratePromise = Promise.resolve().then(() => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw != null && raw !== '') {
          const parsed = clampIndex(parseInt(raw, 10));
          const prev = memoryIndex;
          memoryIndex = parsed;
          if (prev !== memoryIndex) {
            notify();
          }
        }
      } catch {
        /* ignore */
      }
      hydrated = true;
    });
  }
  return hydratePromise;
}
